module.exports = __webpack_public_path__ + "img/Logo_mit_Subline.675dda86.png";